export default __webpack_public_path__ + "static/media/aboutusTop_mobile.f08c13cd.webp";